<section class="product-feature-upgrade-page">
  <div class="product-feature-upgrade-page__hero">
    <div class="product-feature-upgrade-page__effects" aria-hidden="true">
      <span class="product-feature-upgrade-page__gradient"></span>
      <span
        class="product-feature-upgrade-page__wave product-feature-upgrade-page__wave--back"
      ></span>
      <span
        class="product-feature-upgrade-page__wave product-feature-upgrade-page__wave--front"
      ></span>
    </div>

    <div class="product-feature-upgrade-page__content">
      <span class="product-feature-upgrade-page__chip">{{
        (chipKey ? translationService.getTranslationForKey(chipKey) : null)
          | subscribe
      }}</span>

      <h1
        class="product-feature-upgrade-page__heading"
        [innerHTML]="
          (headingKey ? translationService.getTranslationForKey(headingKey) : null)
            | subscribe
        "
      ></h1>

      <p
        class="product-feature-upgrade-page__paragraph"
        [innerHTML]="
          (paragraphKey
            ? translationService.getTranslationForKey(paragraphKey)
            : null) | subscribe
        "
      ></p>

      <tswp-product-feature-upgrade-button
        class="product-feature-upgrade-page__button"
        [productFeatureKey]="productFeatureKey"
        [redirectUrlParams]="redirectUrlParams"
      ></tswp-product-feature-upgrade-button>
    </div>
  </div>
</section>
